// src/components/TermsOfService.js
import React from 'react'

function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        {/* ページタイトル */}
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          利用規約
        </h1>

        {/* サービスの利用 */}
        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            サービスの利用
          </h3>
          <p className="mb-4 text-gray-700">
            本サービスは、弘前大学医学部医学科6年次のクリクラ2配属抽選・最適化を目的としてのみ運営されています。<br />
            ただし、本サービスは弘前大学とは一切の関係がありません。
          </p>
          <p className="mb-4 text-gray-700">
            本サービスに登録された情報は、厳重に管理されます。運営者は不正アクセスや情報漏洩を防ぐために適切なセキュリティ対策を講じており、
            利用者の個人情報保護を最優先としています。
          </p>
        </section>

        {/* 禁止事項 */}
        <section className="mb-8">
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            禁止事項
          </h3>
          <ul className="ml-6 list-disc text-gray-700">
            <li className="mb-2">
              本サービスの不正利用（虚偽情報の登録、複数アカウントの作成など）
            </li>
            <li className="mb-2">第三者へのアカウントの貸与・譲渡</li>
            <li className="mb-2">
              本サービスのシステムの改変・解析行為、またはその試み
            </li>
            <li className="mb-2">
              サービスの目的外利用（本サービスはクリクラ2配属抽選のみに使用）
            </li>
            <li>
              運営者の許可なく、本サイトのコンテンツを転載・再利用する行為
            </li>
          </ul>
        </section>

        {/* サービスの変更・停止 */}
        <section>
          <h3 className="mt-4 mb-4 text-2xl font-semibold border-b-2 border-gray-300 pb-2 text-primary">
            サービスの変更・停止
          </h3>
          <p className="mb-4 text-gray-700">
            本サービスは、技術的要因または運営上の必要性に応じて、予告なく変更・停止される場合があります。
            運営者は、利用者がこれらによって被る損害について一切責任を負いません。
          </p>
          <p className="mb-0 text-gray-500 text-sm">
            ※ 利用規約は随時改定される可能性があり、利用者は常に最新の規約に従うものとします。
          </p>
        </section>
      </div>
    </div>
  )
}

export default TermsOfService;
